<template>
    <router-link class="shop" tag="div" :to="{name: 'shop', params: {id: shop.id}}">
        <div class="title">
            {{ shop.alias }}
        </div>
        <div class="content">
            <div class="work">
                營業時間：<pre>{{ shop.work }}</pre>
            </div>
            <img src="@/assets/img/next-gray.png">
        </div>
    </router-link>
</template>

<script>
    export default {
        name: 'ShopItem',
        props: ['shop'],
    };
</script>

<style scoped>
    .content > img {
        width: 20px;
        height: 20px;
    }

    .shop {
        display: flex;
        flex-direction: column;
        text-align: left;
        margin: 0 15px;
        margin-top: 10px;
        padding: 10px;
        border-radius: 5px;
        background-color: rgba(255,255,255,1);
        box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
    }

    .content {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        align-items: center;
    }

    .title {
        color: rgba(0,0,0,1);
        font-family: "PingFang TC";
        font-size: 14px;
        line-height: 20px;
    }

    .work {
        color: rgba(120,120,120,1);
        font-family: "PingFang TC";
        font-size: 12px;
        line-height: 17px;
        display: flex;
    }

    .work > pre {
        margin: 0;
        max-width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
